import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-public-layout-header',
  templateUrl: './public-layout-header.component.html',
  styleUrl: './public-layout-header.component.scss',
})
export class PublicLayoutHeader {}
